export default "__VITE_ASSET__BspX4GZc__"